import type { SVGProps } from 'react';

export const InputDropdown = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'input dropdown'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <circle cx="16" cy="16" fill="#F2F4F9" r="16" />
      <g transform="translate(4, 10)">
        <g>
          <polygon points="0 0 24 0 24 12 0 12" />
          <path
            d="M22.79793,9.24891581 C22.79793,10.1338479 22.0429998,10.8537149 21.1149646,10.8537149 L14.3999327,10.8537149 L14.3999327,1.14628508 L21.1149646,1.14628508 C22.0429998,1.14628508 22.79793,1.86615211 22.79793,2.75108419 L22.79793,9.24891581 Z M2.88508352,10.8537149 C1.95704832,10.8537149 1.20211813,10.1338479 1.20211813,9.24891581 L1.20211813,2.75108419 C1.20211813,1.86615211 1.95704832,1.14628508 2.88508352,1.14628508 L13.1978145,1.14628508 L13.1978145,10.8537149 L2.88508352,10.8537149 Z M21.1149646,0 L2.88508352,0 C1.29828758,0 0,1.23798789 0,2.75108419 L0,9.24891581 C0,10.7620121 1.29828758,12 2.88508352,12 L13.1978145,12 L13.1978145,12 L14.3999327,12 L14.3999327,12 L21.1149646,12 C22.7017605,12 24.0000481,10.7620121 24.0000481,9.24891581 L24.0000481,2.75108419 C24.0000481,1.23798789 22.7017605,0 21.1149646,0 L21.1149646,0 Z"
            fill="#898C9A"
          />
        </g>
        <polygon
          fill="#898C9A"
          points="18.7993725 7.17934394 21.2163512 4.8205185 16.3557068 4.8205185"
        />
        <path
          d="M11.0833849,5.24975641 L3.59683362,5.24975641 C3.52013848,5.24975641 3.45810919,5.35246356 3.45810919,5.47901343 L3.45810919,6.16678448 C3.45810919,6.29333435 3.52013848,6.3960415 3.59683362,6.3960415 L11.0833849,6.3960415 C11.1600801,6.3960415 11.2221094,6.29333435 11.2221094,6.16678448 L11.2221094,5.47901343 C11.2221094,5.35246356 11.1600801,5.24975641 11.0833849,5.24975641"
          fill="#898C9A"
        />
      </g>
    </g>
  </svg>
);
